import React from "react";
import { connect } from "react-redux";

import {
	Button,
	Input,
	Icon
} from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import ReduxComponent from '../ReduxComponent';
import {
	changeHiringManagement,
	selectHiringManagement,
} from "../../actions/recruitment-actions";
import hiringManagementService from "../../services/Recruitment/hiring-management-service";



class HiringManagement extends ReduxComponent {

	initReload = true;
	moduleName = "recruitment";
	childModuleName = "hiringManagement";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
	}

	actions = {
		changeAction: this.props.changeHiringManagement,
		selectAction: this.props.selectHiringManagement,
		deleteAction: hiringManagementService.deleteHiringManagement,
	}

	setNameFilter = value => this.actions.changeAction({username: value}, "reload")

	changeNameFilter = event => {
		if (!event.target.value) {
			this.actions.changeAction({username: ""}, "reload")
		}
	}

	column = [{
    title: '部门',
    dataIndex: 'department_name',
    key: 'department_name',
    className: 'table-global-head-short'
  }, {
    title: '职位',
    dataIndex: 'position_name',
    key: 'position_name',
    className: 'table-global-head-short'
  },{
			title: '姓名',
			dataIndex: 'username',
			key: 'username',
			className: 'table-global-head-short'
		}, {
    title: '电话',
    dataIndex: 'mobile',
    key: 'mobile',
    className: 'table-global-head-short'
  }, {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email',
    className: 'table-global-head-short'
  },{
			title: 'offer发送时间',
			dataIndex: 'employ_time_str',
			key: 'employ_time_str',
			className: 'table-global-head'
		}, {
			title: '入职时间',
			dataIndex: 'onboarding_time_str',
			key: 'onboarding_time_str',
			className: 'table-global-head'
		}
	];

	render() {
		return (
			<div className="app-module-item">
				<div style={{marginBottom: "20px"}}>
					{this.props.access.hiringManagement.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
					<div className="colAction" style={{float:"right", margin:"0px 10px 10px 0px"}}>
						<Input.Search
							placeholder="姓名或职位"
							onSearch={this.setNameFilter}
							onChange={this.changeNameFilter}
							style={{ width: 200 }}
							defaultValue={this.props[this.moduleName][this.childModuleName].filters.name}
							enterButton />
					</div>
					<div style={{clear: "both"}}></div>
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		recruitment: state.recruitment
	}
}

const mapDispatchToProps = {
	changeHiringManagement,
	selectHiringManagement,
}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(HiringManagement));







// WEBPACK FOOTER //
// ./src/routes/Recruitment/HiringManagement.js